// eslint-disable-next-line import/prefer-default-export
import api from '../API';
import { Account } from '../types';

export const type = {
  SERVICE_PROVIDER: 1,
  CUSTOMER: 2,
  CLIENT: 3,
};

export class AccountType {
  static CUSTOMER: number = 3;

  static isServiceProvider(accountType: number) {
    return (accountType === type.SERVICE_PROVIDER);
  }

  static isCustomer(accountType: number) {
    return (accountType === type.CUSTOMER);
  }

  static toString(accountType: number): string {
    const labels:{[key: number]: string} = {};
    labels[type.SERVICE_PROVIDER] = 'Service Provider';
    labels[type.CUSTOMER] = 'Law Firm';
    return labels[accountType] || 'Unknown';
  }
}

export async function updateNumFreeTrials(
  accountId: number,
  numOfFreeTrials: number,
): Promise<Account> {
  const response = await api.post(`accounts/${accountId}/num-free-trials`, { numOfFreeTrials });
  return response.data;
}
